// actionTypes.js
export const CREATE_MESSAGE_REQUST = 'CREATE_MESSAGE_REQUEST';
export const CREATE_MESSAGE_SUCCESS = 'CREATE_MESSAGE_SUCCESS';
export const CREATE_MESSAGE_FAILURE = 'CREATE_MESSAGE_FAILURE';

export const DELETE_MESSAGE_REQUEST = 'DELETE_MESSAGE_REQUEST';
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';

export const CREATE_CHAT_REQUEST = 'CREATE_CHAT_REQUEST';
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS';
export const CREATE_CHAT_FAILURE = 'CREATE_CHAT_FAILURE';

export const GET_ALL_CHATS_REQUEST = 'GET_ALL_CHATS_REQUEST';
export const GET_ALL_CHATS_SUCCESS = 'GET_ALL_CHATS_SUCCESS';
export const GET_ALL_CHATS_FAILURE = 'GET_ALL_CHATS_FAILURE';
